import axios from 'axios';
export class AxiosBackendInstance {
    constructor(baseUrl) {
        const baseURL = baseUrl ? `${baseUrl.sheme}://${baseUrl.endpoint}${baseUrl.port ? `:${parseInt(baseUrl.port).toString()}` : ''}` : undefined;
        this.axiosInstance = axios.create({ baseURL });
        console.log(`${this.constructor.name} with backend base url: ${baseURL}`);
    }
}
